import React from "react";
import { whatsappUrl } from "./util/whatsappUrl";
import { trackWhatsapp } from "./util/analytics";

const Contact = ({ fundoAnterior = "gray" }) => {
  return (
    <div className="scroll-mt-24 xl:scroll-mt-32" id="contato">
      <div className={fundoAnterior === "white" ? "fade-white-to-blue" : "fade-gray-to-blue"} aria-hidden="true" />
      <div className="bg-sky-contact">
      <div className="text-white w-3/4 mx-auto xl:py-48 py-24 xl:text-center">
        <p className="text-sm font-semibold uppercase tracking-widest text-secondary mb-4">Contato</p>
        <h2 className="text-3xl xl:text-5xl font-semibold">
          Vamos conversar sobre o seu problema?
        </h2>
        <p className="text-xl xl:text-2xl leading-relaxed mt-6 mb-10 xl:w-2/3 xl:mx-auto">
          Conte onde está o gargalo da sua operação. A conversa é sem compromisso e o orçamento é gratuito.
        </p>
        <a
          href={whatsappUrl("Olá! Vi o site da Hawx e quero conversar sobre um projeto.")}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackWhatsapp("contato")}
          className="btn-glass font-semibold py-6 px-8 rounded-full block xl:inline-block text-xl text-center w-full xl:w-auto"
        >
          Falar no WhatsApp
        </a>
        <p className="text-lg mt-8">
          {"Ou escreva para "}
          <a href="mailto:contato@hawx.com.br" className="underline hover:text-secondary">
            contato@hawx.com.br
          </a>
        </p>
      </div>
      </div>
    </div>
  );
};

export default Contact;
